import React, { CSSProperties, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  bannerContainerStyle,
  bannerIconWrapperStyle,
  textContainerStyle
} from './styles.ts';

import { useProfileStore } from '@/store/useProfileStore.ts';
import Modal from '@/animations/Modal.tsx';
import PaywallPopup from '@/components/Popup/PaywallPopup/PaywallPopup.tsx';
import { PaywallTypes, ProductInvoicePlacements } from '@/enums/apiEnums.ts';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import UIConfig from '@/UIConfig.ts';
import PlusSimpleShape from '@/components/common/svg/shapes/PlusSimpleShape.tsx';

export const ReactionsBanner: React.FC = () => {
  const { t } = useTranslation();
  const { remainingAmount } = useProfileStore();
  const [payWallOpen, setPayWallOpen] = useState<boolean>(false);

  const closePayWall = () => setPayWallOpen(false);
  const openPayWall = () => setPayWallOpen(true);

  return (
    <div style={containerStyle} onClick={openPayWall}>
      <div style={flexContainerStyle}>
        <div style={iconWrapperStyle}>
          <FireReactionShape
            width={20}
            height={20}
            fillColor="#FFF"
            style={fireReactionStyle}
          />
          <div style={plusIconContainerStyle}>
            <div style={plusIconInnerStyle}>
              <PlusSimpleShape width={8} height={8} fillColor="#FFF" />
            </div>
          </div>
        </div>
        <div style={textContainerStyle}>
          <p style={titleStyle}>{t('gifts_menu_item')}</p>
          <span style={subtitleStyle}>
            {remainingAmount > 0
              ? `${t('balance')}: ${remainingAmount} `
              : t('add')}
          </span>
        </div>
      </div>

      <Modal fullScreen open={payWallOpen} handleClose={closePayWall}>
        <PaywallPopup
          handleClose={closePayWall}
          type={PaywallTypes.TYPE_ONE_TIME}
          placement={ProductInvoicePlacements.PROFILE_PAGE_GET_REACTIONS}
          prevHeaderTemplate="light"
        />
      </Modal>
    </div>
  );
};

const containerStyle: CSSProperties = {
  ...bannerContainerStyle,
  backgroundColor: '#FFF',
  width: '168px',
  height: '67px'
};

const flexContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center'
};

const iconWrapperStyle: CSSProperties = {
  ...bannerIconWrapperStyle,
  background: UIConfig.Colors.PrimaryGradient,
  position: 'relative'
};

const fireReactionStyle: CSSProperties = {
  marginBottom: '2px'
};

const plusIconContainerStyle: CSSProperties = {
  position: 'absolute',
  bottom: '-3px',
  right: '-3px',
  width: '16px',
  height: '16px',
  backgroundColor: '#FFF',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const plusIconInnerStyle: CSSProperties = {
  width: '12px',
  height: '12px',
  background: UIConfig.Colors.PrimaryGradient,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const titleStyle: CSSProperties = {
  margin: 0,
  fontWeight: 'bold',
  fontSize: '14px'
};

const subtitleStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: '400',
  color: '#000'
};
